export default __webpack_public_path__ + "static/media/11.5.f31a34b2.jpg";